import React, { useEffect, useState } from 'react';

export default function Popup1({ name, setValue,otherAllowedUnits, setSelectedValue  }) {
  const [showPopup, setShowPopup] = useState(false);
  const [value, setLocalValue] = useState('');;
  const [otherallowedunits, setOtherallowedunits] = useState([]);

  const togglePopup = () => setShowPopup(!showPopup);

  const handleSelect = (selectedValue) => {
    setLocalValue(selectedValue)
    setSelectedValue(selectedValue); // Pass value to parent
    togglePopup() // Close popup after selection
  };

  useEffect(()=>{
    if(setValue){
      setLocalValue(setValue);
      // setOtherallowedunits.Append(setValue)
    }
  },[setValue])

  useEffect(()=>{
    if(otherAllowedUnits){
      setOtherallowedunits(otherAllowedUnits.split(','))     
    }
  },[otherAllowedUnits])

  return (
    <div className=" font-normal">
      <div className="flex flex-col">
        <label htmlFor="measureUnit" className="font-semibold text-[#667085]">
          {name}
        </label>
        <div className="flex w-full mt-2 space-x-2 relative">
          <input
            id="measureUnit"
            name="default_unit"
            value={value ? value.charAt(0).toUpperCase() + value.slice(1).toLowerCase() : ""}
            type="text"
            className="flex-1 p-2 border border-gray-300 rounded-md"
            placeholder="Enter unit of measure..."
            readOnly
            autoCapitalize
          />
          <button
            type="button"
            onClick={togglePopup}
            className="bg-[#0C92CC] px-4 py-2 text-white rounded-md"
          >
            Change
          </button>

          {showPopup && (
            <div className="absolute top-full left-0 mt-2 w-[250px] bg-white border border-gray-300 rounded-md shadow-lg p-4 z-10">
              <form>
                {otherallowedunits.map((unit) => (
                  <div
                    key={unit}
                    className="flex items-center py-2 hover:bg-sky-200 group cursor-pointer"
                    onClick={() => handleSelect(unit)}
                  >
                    <input
                      type="radio" // Use type="radio" instead of type="text"
                      id={unit.toLowerCase()}
                      name="measureUnit"
                      value={unit}
                      checked={value === unit}
                      className="cursor-pointer border-none outline-none group-hover:bg-sky-200 text-center"
                      readOnly
                    />
                    <label htmlFor={unit.toLowerCase()} className="ml-2 cursor-pointer capitalize">
                      {unit}
                    </label>
                  </div>
                ))}
              </form>
              {/* Cancel Button */}
              <div className="flex justify-end space-x-2 mt-4">
                <button
                  type="button"
                  onClick={togglePopup}
                  className="bg-gray-300 px-4 py-2 text-gray-700 rounded-md"
                >
                  Cancel
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}